<template>
  <page-column>
    <div id="mobile">
      <Header :lang="lang"></Header>
      <Main :lang="lang"></Main>
      
    </div>
  </page-column>
</template>

<script>
import Header from './components/mobile/header.vue'
import Main from './views/Main.mobile.vue'

export default {
  name: 'Mobile',
  components: {
    Header,
    Main,

  },
  props: {
    lang: {}
  },
  data() {
    return {
      currentLanguage: "",
    }
  },
  mounted() {
    console.log('zz',this.$route)
  },
  methods: {
    
  }
}
</script>
<style></style>


